/**
 * The Live card's verdict wording (moved from GroupLiveRows, 19/10/2026, so
 * a list's own row can say it too): the badge tone, what scaling did and what
 * the verdict did, in the operator's words.
 * For Media Devoted | Created By Ciro Autiero
 */
import type { DropGenGroupVerdict } from '@trafficpulse/shared';

export const VERDICT_TONE: Record<string, 'success' | 'destructive' | 'secondary' | 'info'> = {
  PASS: 'success',
  FAIL: 'destructive',
  INCONCLUSIVE: 'secondary',
  PENDING: 'info',
};

/** Phase 10 — what scaling did, in the operator's words. */
export function scalingCopy(s: NonNullable<DropGenGroupVerdict['scaling']>): string {
  if (s.steps < 0) {
    const shrink = `shrunk ${-s.steps} step${s.steps === -1 ? '' : 's'} down — next drops ×${s.factor}`;
    if (s.floored) return `${shrink} · at the floor`;
    return s.performing === 'weak' ? `${shrink} · still weak` : shrink;
  }
  const growth = `scaled ${s.steps} step${s.steps === 1 ? '' : 's'} — next drops ×${s.factor}`;
  if (s.capped) return `${growth} · at the cap`;
  if (s.performing === 'yes') return s.stale ? `${growth} · still performing, same results as the last step — no new step` : `${growth} · still performing`;
  if (s.performing === 'guarded') return `${growth} · the guard holds — no further step`;
  return growth;
}

/** What the verdict did, in the operator's words. */
export function actionCopy(v: DropGenGroupVerdict): string {
  if (v.action === 'burned') return 'burned — tomorrow starts on the next list';
  if (v.action === 'burned_and_stopped')
    return 'burned — the rest of today is stopped; tomorrow starts on the next list';
  return '';
}
